// Libellés affichés dans l'interface. Ils vivent ici pour que l'API et
// l'interface ne divergent jamais sur le vocabulaire.
export const MODES_DOSSIER = {
    GYNECOLOGIE_BENIGNE: 'Gynécologie bénigne',
    OBSTETRIQUE: 'Obstétrique / grossesse',
    ONCOLOGIE: 'Chirurgie oncologique',
};
export const TYPES_VENUE = {
    CONSULTATION: 'Consultation',
    HOSPITALISATION: 'Hospitalisation',
    INTERVENTION: 'Intervention',
    AUTRE: 'Autre prise en charge',
};
export const TYPES_DOCUMENT = {
    INDETERMINE: 'Type non déterminé',
    COMPTE_RENDU_CONSULTATION: 'Compte rendu de consultation',
    COMPTE_RENDU_OPERATOIRE: 'Compte rendu opératoire',
    COMPTE_RENDU_HOSPITALISATION: "Compte rendu d'hospitalisation",
    COMPTE_RENDU_IMAGERIE: "Compte rendu d'imagerie",
    COMPTE_RENDU_ANAPATH: "Compte rendu d'anatomo-pathologie",
    BILAN_BIOLOGIQUE: 'Bilan biologique',
    COURRIER: 'Courrier',
    ORDONNANCE: 'Ordonnance',
    FICHE_BLOC: 'Fiche de bloc',
    DEMANDE_ANAPATH: "Demande d'anatomo-pathologie",
    AUTRE: 'Autre document',
};
export const ORIGINES_DOCUMENT = {
    DEPOT_FICHIER: 'Fichier déposé',
    TEXTE_COLLE: 'Texte collé',
    EMAIL: 'Reçu par e-mail',
    GENERE: "Généré par l'application",
};
export const CATEGORIES_DONNEE = {
    ANTECEDENT: 'Antécédent',
    ALLERGIE: 'Allergie',
    DIAGNOSTIC: 'Diagnostic',
    TRAITEMENT: 'Traitement',
    RESULTAT_BIOLOGIQUE: 'Résultat biologique',
    EVENEMENT_HISTOIRE: 'Événement',
    DONNEE_SPECIFIQUE: 'Donnée spécifique',
};
export const TYPES_ANTECEDENT = {
    MEDICAL: 'Médical',
    CHIRURGICAL: 'Chirurgical',
    GYNECOLOGIQUE: 'Gynécologique',
    OBSTETRICAL: 'Obstétrical',
    FAMILIAL: 'Familial',
    MODE_DE_VIE: 'Mode de vie',
};
export const STATUTS_TRAITEMENT = {
    ACTUEL: 'En cours',
    ARRETE: 'Arrêté',
    ANCIEN: 'Ancien',
};
export const PRECISIONS_DATE = {
    JOUR: 'Date exacte',
    MOIS: 'Mois connu',
    ANNEE: 'Année connue',
    INCERTAINE: 'Date incertaine',
};
export const ETATS_DONNEE = {
    PROPOSEE: 'À vérifier',
    VALIDEE: 'Validée',
    REJETEE: 'Rejetée',
    ARCHIVEE: 'Archivée',
};
export const SEVERITES = {
    INFO: 'Information',
    ATTENTION: 'Attention',
    CRITIQUE: 'Critique',
};
export const SEXES = {
    FEMME: 'Femme',
    HOMME: 'Homme',
    AUTRE: 'Autre',
    NON_RENSEIGNE: 'Non renseigné',
};
export const DECISIONS_CONFLIT = {
    GARDER_EXISTANT: 'Garder la donnée existante',
    REMPLACER: 'Remplacer par la nouvelle',
    CONSERVER_LES_DEUX: 'Conserver les deux',
    EVOLUTION_DATEE: "Il s'agit d'une évolution datée",
};
//# sourceMappingURL=libelles.js.map